let storeInstance: any = null;

export const initializeTenantHelpers = (store: any) => {
  storeInstance = store;
};

export const getCurrentTenantId = (): string | null => {
  if (!storeInstance) return null;

  try {
    const state = storeInstance.getState();
    const tenant = state.tenant?.tenant;
    return tenant?.id || null;
  } catch (error) {
    return null;
  }
};

export const getCurrentTenantSlug = (): string | null => {
  if (!storeInstance) return null;

  try {
    const state = storeInstance.getState();
    const tenant = state.tenant?.tenant;
    return tenant?.slug || null;
  } catch (error) {
    return null;
  }
};

export const getCurrentTenant = () => {
  if (!storeInstance) return null;

  try {
    const state = storeInstance.getState();
    return state.tenant?.tenant || null;
  } catch (error) {
    return null;
  }
};

export const hasTenant = (): boolean => {
  return getCurrentTenantId() !== null;
};

export const getFontPreviewClass = (fontFamily: string) => {
  const fontMap: { [key: string]: string } = {
    'AlbertSans-Regular, sans-serif': 'preview-albertsans-regular',
    'AlbertSans-Medium, sans-serif': 'preview-albertsans-medium',
    'AlbertSans-SemiBold, sans-serif': 'preview-albertsans-semibold',
    'AlbertSans-Bold, sans-serif': 'preview-albertsans-bold',
    'Inter, sans-serif': 'preview-inter',
    'PassionOne-Regular, sans-serif': 'preview-passionone-regular',
    'PassionOne-Bold, sans-serif': 'preview-passionone-bold',
    'PassionOne-Black, sans-serif': 'preview-passionone-black',
    'Sora-Regular, sans-serif': 'preview-sora-regular',
    'Sora-Light, sans-serif': 'preview-sora-light',
    'Helvetica, sans-serif': 'preview-helvetica',
    'Arial, sans-serif': 'preview-arial',
  };
  return fontMap[fontFamily] || 'preview-albertsans-regular';
};
